module.exports = __webpack_public_path__ + "img/check-status-vacinado.8d870259.svg";